import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FilterTab from '../../common/FilterTab';
import SearchBox from '../../common/SearchBox';
import ToggleViewButton from '../../common/ToggleViewbutton';
import FourGrid from '../../icons/FourGrid';
import { useAdvanceTableContext } from '../../../providers/AdvanceTableProvider';

const OrdersProductsTopSection = ({ activeView }) => {
  const navigate = useNavigate();
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext();
  const handleFilterItemClick = (columnId, value) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'all' ? '' : value);
  };

  // computed every render (not memoised) so the counts follow the data as products
  // get planned. The filterable column id is 'deliveryPlan' (accessorFn = planStatus).
  const rows = getPrePaginationRowModel().rows;
  const countBy = label =>
    rows.filter(({ original }) => original.planStatus === label).length;
  const tabItems = [
    {
      label: 'All',
      value: 'all',
      onClick: () => handleFilterItemClick('deliveryPlan', 'all'),
      count: rows.length
    },
    {
      label: 'Planned',
      value: 'planned',
      onClick: () => handleFilterItemClick('deliveryPlan', 'planned'),
      count: countBy('planned')
    },
    {
      label: 'Partial',
      value: 'partial',
      onClick: () => handleFilterItemClick('deliveryPlan', 'partial'),
      count: countBy('partial')
    },
    {
      label: 'Missing',
      value: 'missing',
      onClick: () => handleFilterItemClick('deliveryPlan', 'missing'),
      count: countBy('missing')
    }
  ];

  const handleSearchInputChange = e => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-3">
      <Col xs={12} sm="auto">
        <FilterTab tabItems={tabItems} handleClick={handleFilterItemClick} />
      </Col>

      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Search products"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />

          {/* optional: dacă vrei toggle list/card ca la Projects */}
          <ToggleViewButton
            tooltip="List view"
            active={activeView === 'list'}
            onClick={() => navigate('#')}
          >
            <FontAwesomeIcon icon={faList} className="fs-10" />
          </ToggleViewButton>

          <ToggleViewButton
            tooltip="Card view"
            active={activeView === 'card'}
            onClick={() => navigate('#')}
          >
            <FourGrid />
          </ToggleViewButton>
        </div>
      </Col>
    </Row>
  );
};

export default OrdersProductsTopSection;
